import { render, staticRenderFns } from "./MockData.vue?vue&type=template&id=492ba716&scoped=true&"
import script from "./MockData.vue?vue&type=script&lang=js&"
export * from "./MockData.vue?vue&type=script&lang=js&"
import style0 from "./MockData.vue?vue&type=style&index=0&id=492ba716&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492ba716",
  null
  
)

export default component.exports